"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = __importStar(require("react"));

var remotion_1 = require("remotion");

var calculate_scale_1 = require("./calculate-scale");

var error_boundary_1 = require("./error-boundary");

var player_css_classname_1 = require("./player-css-classname");

var use_thumbnail_1 = require("./use-thumbnail");

var is_node_1 = require("./utils/is-node");

var use_element_size_1 = require("./utils/use-element-size");

var reactVersion = react_1.default.version.split('.')[0];

if (reactVersion === '0') {
  throw new Error("Version ".concat(reactVersion, " of \"react\" is not supported by Remotion"));
}

var doesReactVersionSupportSuspense = parseInt(reactVersion, 10) >= 18;

var ThumbnailUI = function ThumbnailUI(_ref, ref) {
  var style = _ref.style,
      inputProps = _ref.inputProps,
      errorFallback = _ref.errorFallback,
      renderLoading = _ref.renderLoading,
      className = _ref.className;

  var _a, _b, _c;

  var config = remotion_1.Internals.useUnsafeVideoConfig();
  var video = remotion_1.Internals.useVideo();
  var container = (0, react_1.useRef)(null);
  var canvasSize = (0, use_element_size_1.useElementSize)(container, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: false
  });
  var layout = (0, react_1.useMemo)(function () {
    if (!config || !canvasSize) {
      return null;
    }

    return (0, calculate_scale_1.calculateCanvasTransformation)({
      canvasSize: canvasSize,
      compositionHeight: config.height,
      compositionWidth: config.width,
      previewSize: 'auto'
    });
  }, [canvasSize, config]);
  var scale = (_a = layout === null || layout === void 0 ? void 0 : layout.scale) !== null && _a !== void 0 ? _a : 1;
  var thumbnail = (0, use_thumbnail_1.useThumbnail)();
  (0, react_1.useImperativeHandle)(ref, function () {
    var methods = {
      getContainerNode: function getContainerNode() {
        return container.current;
      },
      getScale: function getScale() {
        return scale;
      }
    };
    return Object.assign(thumbnail.emitter, methods);
  }, [scale, thumbnail.emitter]);
  var VideoComponent = video ? video.component : null;
  var outerStyle = (0, react_1.useMemo)(function () {
    return (0, calculate_scale_1.calculateOuterStyle)({
      config: config,
      style: style,
      canvasSize: canvasSize
    });
  }, [canvasSize, config, style]);
  var outer = (0, react_1.useMemo)(function () {
    return (0, calculate_scale_1.calculateOuter)({
      config: config,
      layout: layout,
      scale: scale
    });
  }, [config, layout, scale]);
  var containerStyle = (0, react_1.useMemo)(function () {
    return (0, calculate_scale_1.calculateContainerStyle)({
      canvasSize: canvasSize,
      config: config,
      layout: layout,
      scale: scale
    });
  }, [canvasSize, config, layout, scale]);
  var onError = (0, react_1.useCallback)(function (error) {
    // Pay attention to `this context`
    thumbnail.emitter.dispatchError(error);
  }, [thumbnail.emitter]);
  var rootRef = (0, react_1.useRef)(null);
  (0, react_1.useImperativeHandle)(ref, function () {
    return rootRef.current;
  }, []);
  var loadingMarkup = (0, react_1.useMemo)(function () {
    return renderLoading ? renderLoading({
      height: outerStyle.height,
      width: outerStyle.width
    }) : null;
  }, [outerStyle.height, outerStyle.width, renderLoading]);

  if (!config) {
    return null;
  }

  var content = (0, jsx_runtime_1.jsx)("div", {
    style: outer,
    children: (0, jsx_runtime_1.jsx)("div", {
      style: containerStyle,
      className: player_css_classname_1.PLAYER_CSS_CLASSNAME,
      children: VideoComponent ? (0, jsx_runtime_1.jsx)(error_boundary_1.ErrorBoundary, {
        onError: onError,
        errorFallback: errorFallback,
        children: (0, jsx_runtime_1.jsx)(VideoComponent, _objectSpread(_objectSpread({}, (_b = video === null || video === void 0 ? void 0 : video.defaultProps) !== null && _b !== void 0 ? _b : {}), (_c = inputProps) !== null && _c !== void 0 ? _c : {}))
      }) : null
    })
  });

  if (is_node_1.IS_NODE && !doesReactVersionSupportSuspense) {
    return (0, jsx_runtime_1.jsx)("div", {
      ref: container,
      style: outerStyle,
      className: className,
      children: content
    });
  }

  return (0, jsx_runtime_1.jsx)("div", {
    ref: container,
    style: outerStyle,
    className: className,
    children: (0, jsx_runtime_1.jsx)(react_1.Suspense, {
      fallback: loadingMarkup,
      children: content
    })
  });
};

exports.default = (0, react_1.forwardRef)(ThumbnailUI);